<template>
  <div v-if="haveVettingBookingRequest">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Edit Pending Request</h1>
      </div>
    </div>

    <div class="container-fluid">
      <booking-form
        :property-mutator="setVettingRequestProperty"
        :booking="booking"
        :validationTriggered="validationTriggered"
      >
        <vetting-edit-shortlist slot="shortlist"/>
      </booking-form>

      <div class="dashboard-block">
        <ladda-button
          :click="handleSaveVettingRequestCallback"
          class="btn btn-primary">
          Save Pending Request
        </ladda-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { omit } from 'lodash'
import BookingForm from 'components/booking/BookingForm'
import VettingEditShortlist from './VettingEditShortlist'
import { notify } from 'utils'
import Tags from 'components/misc/Tags'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  props: ['id'],

  mixins: [OpportunityTracker],

  components: {
    Tags,
    BookingForm,
    VettingEditShortlist
  },

  data () {
    return {
      validationTriggered: false
    }
  },

  computed: {
    ...mapState('booking/request/vetting', {
      booking: 'request'
    }),
    ...mapState('shortlist', ['shortlist']),
    ...mapState('booking/request', ['formStatus']),
    ...mapGetters('booking/request/vetting', ['haveVettingBookingRequest'])
  },

  created () {
    this.getVettingBookingRequest({ id: this.id })
  },

  methods: {
    ...mapActions('booking/request/vetting', ['getVettingBookingRequest', 'updateVettingBookingRequest', 'setVettingRequestProperty']),
    ...mapActions('booking/request', ['setFormStatus', 'getFormStatus']),
    ...mapActions('shortlist', ['clearShortlist']),

    validateAll () {
      this.validationTriggered = true
      if (this.formStatus) {
        return Promise.resolve()
      } else {
        return Promise.reject(new Error('The form has validation errors'))
      }
    },

    handleSaveVettingRequestCallback () {
      return this.validateAll().then((response) => {
        const payload = omit(this.booking, ['client', 'opportunity', 'talent', 'id'])

        payload.shortlist = this.shortlist
        this.trackEvent(this.analytics.V2.JobEditEvent)
        this.updateVettingBookingRequest({ id: this.id, payload: payload }).then(() => {
          this.clearShortlist()
          this.$router.push({ name: 'vetting.show', params: { id: this.booking.id } })
        })
      }).catch(() => {
        notify.error('There were form validation issues, please fix them and try again.')
        return Promise.resolve()
      })
    }
  }
}
</script>
